var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 9.4V1H20.2V9.4M5.8 20.2H3.4C2.76348 20.2 2.15303 19.9471 1.70294 19.4971C1.25286 19.047 1 18.4365 1 17.8V11.8C1 11.1635 1.25286 10.553 1.70294 10.1029C2.15303 9.65286 2.76348 9.4 3.4 9.4H22.6C23.2365 9.4 23.847 9.65286 24.2971 10.1029C24.7471 10.553 25 11.1635 25 11.8V17.8C25 18.4365 24.7471 19.047 24.2971 19.4971C23.847 19.9471 23.2365 20.2 22.6 20.2H20.2M5.8 15.4H20.2V25H5.8V15.4Z",
    stroke: "#0045F5",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.984f7f957d4e66d6a0d0f5c21bff69a7.svg";
export { ForwardRef as ReactComponent };